/* @generated from adl module totalinteraction.futurefit.requests-rtypes */

import * as ADL from './../../runtime/adl';
import * as JSON from './../../runtime/json';
import * as common from './../../common';
import * as common_db from './../../common/db';
import * as common_tabular from './../../common/tabular';
import * as totalinteraction_futurefit_db from './db';
import * as totalinteraction_futurefit_db_learningevent from './db/learningevent';
import * as totalinteraction_futurefit_db_scodlemigration from './db/scodlemigration';
import * as totalinteraction_futurefit_frontend from './frontend';
import * as totalinteraction_futurefit_lpapi from './lpapi';
import * as totalinteraction_futurefit_requests from './requests';

export interface PostRequest<I,O> {
  path: string,
  reqJB: JSON.JsonBinding<I>,
  respJB: JSON.JsonBinding<O>,
};

export interface GetRequest<O> {
  path: string,
  respJB: JSON.JsonBinding<O>,
};

export interface PutRequest<I,O> {
  path: string,
  reqJB: JSON.JsonBinding<I>,
  respJB: JSON.JsonBinding<O>,
};

export interface RequestTypes {
  availableLangs: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.Lang>>>,
  captureEvent: PostRequest<totalinteraction_futurefit_frontend.InputEvent, string>,
  checkAuth: GetRequest<(common_db.DbKey<totalinteraction_futurefit_db.AppUser>|null)>,
  clientParticipantsReport: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.AppClient>, common.Paginated<totalinteraction_futurefit_frontend.ClientParticipant>>,
  cloneWorkRole: PostRequest<totalinteraction_futurefit_requests.CloneWorkRoleReq, common_db.DbKey<totalinteraction_futurefit_db.WorkRole>>,
  completeUserQuiz: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.UserQuiz>, common.Unit>,
  createAppClient: PostRequest<totalinteraction_futurefit_db.AppClient, common_db.DbKey<totalinteraction_futurefit_db.AppClient>>,
  createAppClientLicence: PostRequest<totalinteraction_futurefit_db.AppClientLicence, common_db.DbKey<totalinteraction_futurefit_db.AppClientLicence>>,
  createAppClientWithGroup: PostRequest<totalinteraction_futurefit_db.AppClient, common_db.DbKey<totalinteraction_futurefit_db.AppClient>>,
  createAuth0Client: PostRequest<totalinteraction_futurefit_requests.CreateAuth0ClientReq, totalinteraction_futurefit_frontend.Auth0Client>,
  createAuth0SamlConnection: PostRequest<totalinteraction_futurefit_db.Auth0SamlConnection, common_db.DbKey<totalinteraction_futurefit_db.Auth0SamlConnection>>,
  createAuth0Tenant: PostRequest<totalinteraction_futurefit_db.Auth0Tenant, common_db.DbKey<totalinteraction_futurefit_db.Auth0Tenant>>,
  createCompetency: PostRequest<totalinteraction_futurefit_db.Competency, common_db.DbKey<totalinteraction_futurefit_db.Competency>>,
  createCompetencyTrainingOffering: PostRequest<totalinteraction_futurefit_db.CompetencyTrainingOffering, common_db.DbKey<totalinteraction_futurefit_db.CompetencyTrainingOffering>>,
  createLang: PostRequest<totalinteraction_futurefit_db.Lang, common_db.DbKey<totalinteraction_futurefit_db.Lang>>,
  createLearningProvider: PostRequest<totalinteraction_futurefit_db.LearningProvider, common_db.DbKey<totalinteraction_futurefit_db.LearningProvider>>,
  createLearningProviderCatalogEntry: PostRequest<totalinteraction_futurefit_db.LearningProviderCatalogEntry, common_db.DbKey<totalinteraction_futurefit_db.LearningProviderCatalogEntry>>,
  createLearningProviderEnrolment: PostRequest<totalinteraction_futurefit_requests.LPEnrolmentCreateReq, totalinteraction_futurefit_lpapi.ResponseType<totalinteraction_futurefit_lpapi.Enrolment>>,
  createLearningProviderUser: PostRequest<totalinteraction_futurefit_requests.LPUserCreateReq, totalinteraction_futurefit_lpapi.ResponseType<totalinteraction_futurefit_lpapi.User>>,
  createLicence: PostRequest<totalinteraction_futurefit_db.Licence, common_db.DbKey<totalinteraction_futurefit_db.Licence>>,
  createQuestion: PostRequest<totalinteraction_futurefit_db.Question, common_db.DbKey<totalinteraction_futurefit_db.Question>>,
  createQuiz: PostRequest<totalinteraction_futurefit_requests.CreateQuizReq, common_db.DbKey<totalinteraction_futurefit_db.Quiz>>,
  createReport: PostRequest<totalinteraction_futurefit_db.Report, common_db.DbKey<totalinteraction_futurefit_db.Report>>,
  createScodleControl: PostRequest<totalinteraction_futurefit_db_scodlemigration.ScodleControl, common_db.DbKey<totalinteraction_futurefit_db_scodlemigration.ScodleControl>>,
  createScodleEvent: PostRequest<totalinteraction_futurefit_db_learningevent.ScodleEventLog, common_db.DbKey<totalinteraction_futurefit_db_learningevent.ScodleEventLog>>,
  createSkill: PostRequest<totalinteraction_futurefit_db.Skill, common_db.DbKey<totalinteraction_futurefit_db.Skill>>,
  createSkillTrainingOffering: PostRequest<totalinteraction_futurefit_db.SkillTrainingOffering, common_db.DbKey<totalinteraction_futurefit_db.SkillTrainingOffering>>,
  createTrainingOffering: PostRequest<totalinteraction_futurefit_db.TrainingOffering, common_db.DbKey<totalinteraction_futurefit_db.TrainingOffering>>,
  createUser: PostRequest<totalinteraction_futurefit_db.AppUser, common_db.DbKey<totalinteraction_futurefit_db.AppUser>>,
  createUserGroup: PostRequest<totalinteraction_futurefit_db.UserGroup, common_db.DbKey<totalinteraction_futurefit_db.UserGroup>>,
  createUserGroupManager: PostRequest<totalinteraction_futurefit_db.UserGroupManager, common_db.DbKey<totalinteraction_futurefit_db.UserGroupManager>>,
  createUserGroupMember: PostRequest<totalinteraction_futurefit_db.UserGroupMember, common_db.DbKey<totalinteraction_futurefit_db.UserGroupMember>>,
  createUserGroupViewer: PostRequest<totalinteraction_futurefit_db.UserGroupViewer, common_db.DbKey<totalinteraction_futurefit_db.UserGroupViewer>>,
  createUserQuiz: PostRequest<totalinteraction_futurefit_db.UserQuiz, common_db.DbKey<totalinteraction_futurefit_db.UserQuiz>>,
  createUserTrainingOffering: PostRequest<totalinteraction_futurefit_db.UserTrainingOffering, common_db.DbKey<totalinteraction_futurefit_db.UserTrainingOffering>>,
  createUserUploadRecord: PostRequest<totalinteraction_futurefit_db.UserUploadRecord, common_db.DbKey<totalinteraction_futurefit_db.UserUploadRecord>>,
  createUserUploadSet: PostRequest<totalinteraction_futurefit_db.UserUploadSet, common_db.DbKey<totalinteraction_futurefit_db.UserUploadSet>>,
  createUserWithGroup: PostRequest<totalinteraction_futurefit_db.AppUser, common_db.DbKey<totalinteraction_futurefit_db.AppUser>>,
  createWorkRole: PostRequest<totalinteraction_futurefit_db.WorkRole, common_db.DbKey<totalinteraction_futurefit_db.WorkRole>>,
  createWorkRoleScoreRange: PostRequest<totalinteraction_futurefit_db.WorkRoleScoreRange, common_db.DbKey<totalinteraction_futurefit_db.WorkRoleScoreRange>>,
  createWorkRoleSkill: PostRequest<totalinteraction_futurefit_db.WorkRoleSkill, common_db.DbKey<totalinteraction_futurefit_db.WorkRoleSkill>>,
  createWorkRoleWithRanges: PostRequest<totalinteraction_futurefit_requests.CreateWorkRoleReq, common_db.DbKey<totalinteraction_futurefit_db.WorkRole>>,
  deleteAppClient: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.AppClient>, common.Unit>,
  deleteAppClientLicence: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.AppClientLicence>, common.Unit>,
  deleteAuth0SamlConnection: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.Auth0SamlConnection>, common.Unit>,
  deleteAuth0Tenant: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.Auth0Tenant>, common.Unit>,
  deleteCompetency: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.Competency>, common.Unit>,
  deleteCompetencyTrainingOffering: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.CompetencyTrainingOffering>, common.Unit>,
  deleteLang: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.Lang>, common.Unit>,
  deleteLearningProvider: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.LearningProvider>, common.Unit>,
  deleteLearningProviderCatalogEntry: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.LearningProviderCatalogEntry>, common.Unit>,
  deleteLicence: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.Licence>, common.Unit>,
  deleteQuestion: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.Question>, common.Unit>,
  deleteReport: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.Report>, common.Unit>,
  deleteRepositoryEntry: PostRequest<totalinteraction_futurefit_requests.RepositoryReq, common.Unit>,
  deleteScodleControl: PostRequest<common_db.DbKey<totalinteraction_futurefit_db_scodlemigration.ScodleControl>, common.Unit>,
  deleteScodleEvent: PostRequest<common_db.DbKey<totalinteraction_futurefit_db_learningevent.ScodleEventLog>, common.Unit>,
  deleteSkill: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.Skill>, common.Unit>,
  deleteSkillTrainingOffering: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.SkillTrainingOffering>, common.Unit>,
  deleteTrainingOffering: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.TrainingOffering>, common.Unit>,
  deleteUser: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.AppUser>, common.Unit>,
  deleteUserGroup: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.UserGroup>, common.Unit>,
  deleteUserGroupManager: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.UserGroupManager>, common.Unit>,
  deleteUserGroupMember: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.UserGroupMember>, common.Unit>,
  deleteUserGroupViewer: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.UserGroupViewer>, common.Unit>,
  deleteUserQuiz: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.UserQuiz>, common.Unit>,
  deleteUserTrainingOffering: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.UserTrainingOffering>, common.Unit>,
  deleteUserUploadRecord: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.UserUploadRecord>, common.Unit>,
  deleteUserUploadSet: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.UserUploadSet>, common.Unit>,
  deleteWorkRole: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.WorkRole>, common.Unit>,
  deleteWorkRoleScoreRange: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.WorkRoleScoreRange>, common.Unit>,
  deleteWorkRoleSkill: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.WorkRoleSkill>, common.Unit>,
  deleteWorkRoleWithRanges: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.WorkRole>, common.Unit>,
  generateCompletionEvent: PostRequest<totalinteraction_futurefit_db_learningevent.CompletionEvent, totalinteraction_futurefit_frontend.InputEvent>,
  generateLoginEvent: PostRequest<totalinteraction_futurefit_db_learningevent.LoginEvent, totalinteraction_futurefit_frontend.InputEvent>,
  generateViewEvent: PostRequest<totalinteraction_futurefit_db_learningevent.ViewEvent, totalinteraction_futurefit_frontend.InputEvent>,
  getCompletionEvent: PostRequest<totalinteraction_futurefit_requests.LaunchTrainingOfferingReq, totalinteraction_futurefit_requests.CompletionEventResp>,
  getNextQuestion: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.UserQuiz>, totalinteraction_futurefit_requests.NextQuestionResp>,
  getWorkRoleForUserQuiz: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.UserQuiz>, totalinteraction_futurefit_frontend.WorkRoleListEntry>,
  launchTrainingOffering: PostRequest<totalinteraction_futurefit_requests.LaunchTrainingOfferingReq, totalinteraction_futurefit_requests.LaunchTrainingOfferingResp>,
  listAuth0Clients: PostRequest<common_tabular.TableQuery, common.Paginated<totalinteraction_futurefit_frontend.Auth0Client>>,
  listRepositoryEntries: PostRequest<totalinteraction_futurefit_requests.RepositoryReq, totalinteraction_futurefit_frontend.RepositoryEntries>,
  processUserUpload: PostRequest<totalinteraction_futurefit_requests.UserUploadData, totalinteraction_futurefit_requests.UserUploadResult>,
  purgeUserQuiz: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.UserQuiz>, common.Unit>,
  queryAppClientLicences: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.AppClientLicence>>>,
  queryAppClientList: PostRequest<common_tabular.TableQuery, common.Paginated<totalinteraction_futurefit_frontend.AppClientListEntry>>,
  queryAppClients: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.AppClient>>>,
  queryAppUserData: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.AppClient>, totalinteraction_futurefit_requests.UserData>,
  queryAppUserList: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.AppClient>, common.Paginated<totalinteraction_futurefit_frontend.AppUserListEntry>>,
  queryAuth0SamlConnections: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.Auth0SamlConnection>>>,
  queryAuth0Tenants: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.Auth0Tenant>>>,
  queryComparisonRoles: PostRequest<common.Unit, totalinteraction_futurefit_frontend.ComparisonRoles>,
  queryCompetencies: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.Competency>>>,
  queryCompetencyTrainingOfferings: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.CompetencyTrainingOffering>>>,
  queryGroupResultsScoreSet: PostRequest<totalinteraction_futurefit_requests.GroupResultScoreSetReq, totalinteraction_futurefit_frontend.ResultsScoreSet>,
  queryLangs: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.Lang>>>,
  queryLearningProviderCatalog: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.LearningProvider>, totalinteraction_futurefit_lpapi.ResponseType<totalinteraction_futurefit_lpapi.ResultsType<totalinteraction_futurefit_lpapi.CatalogEntry>>>,
  queryLearningProviderCatalogEntrys: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.LearningProviderCatalogEntry>>>,
  queryLearningProviderEnrolment: PostRequest<totalinteraction_futurefit_requests.EnrolmentQueryReq, totalinteraction_futurefit_lpapi.ResponseType<totalinteraction_futurefit_lpapi.ResultsType<totalinteraction_futurefit_lpapi.Enrolment>>>,
  queryLearningProviderUser: PostRequest<totalinteraction_futurefit_requests.LPUserQueryReq, totalinteraction_futurefit_lpapi.ResponseType<totalinteraction_futurefit_lpapi.ResultsType<totalinteraction_futurefit_lpapi.User>>>,
  queryLearningProviders: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.LearningProvider>>>,
  queryLicences: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.Licence>>>,
  queryQuestions: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.Question>>>,
  queryQuizQuestions: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.QuizQuestion>>>,
  queryQuizReportMulti: PostRequest<totalinteraction_futurefit_requests.QueryQuizReportResultsReq, totalinteraction_futurefit_frontend.MultiUserQuizResults>,
  queryQuizReportParticipants: PostRequest<totalinteraction_futurefit_requests.QueryQuizReportParticipantsReq, totalinteraction_futurefit_frontend.UsersGroupsMap>,
  queryQuizReportRaw: PostRequest<totalinteraction_futurefit_requests.QueryQuizReportRawResultsReq, totalinteraction_futurefit_requests.TempMultiUserQuizResultsRaw>,
  queryQuizReports: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.AppUser>, common.Paginated<totalinteraction_futurefit_requests.QuizReportSummary>>,
  queryQuizSkills: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.QuizSkill>>>,
  queryQuizTrainingRecommendations: PostRequest<totalinteraction_futurefit_requests.QueryQuizTrainingOfferingsDataReq, totalinteraction_futurefit_frontend.MultiUserTrainingRecommendations>,
  queryQuizzes: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.Quiz>>>,
  queryQuizzesForUser: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.AppUser>, common.Paginated<totalinteraction_futurefit_frontend.UserQuizSummary>>,
  queryReports: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.Report>>>,
  queryRoleBuilderData: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.WorkRole>, totalinteraction_futurefit_frontend.RoleBuilderData>,
  queryScodleControls: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db_scodlemigration.ScodleControl>>>,
  queryScodleEvents: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db_learningevent.ScodleEventLog>>>,
  querySkillData: PostRequest<totalinteraction_futurefit_requests.QuerySkillDataReq, totalinteraction_futurefit_frontend.SkillData>,
  querySkillTrainingOfferings: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.SkillTrainingOffering>>>,
  querySkills: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.Skill>>>,
  queryTrainingOfferingData: PostRequest<totalinteraction_futurefit_requests.QueryTrainingOfferingDataReq, totalinteraction_futurefit_frontend.TrainingOfferingData>,
  queryTrainingOfferings: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.TrainingOffering>>>,
  queryUserAttemptHistory: PostRequest<totalinteraction_futurefit_requests.QueryUserAttemptHistoryReq, totalinteraction_futurefit_requests.UserAttemptHistoryRaw>,
  queryUserGroupData: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.AppClient>, totalinteraction_futurefit_requests.GroupData>,
  queryUserGroupList: PostRequest<common_db.DbKey<totalinteraction_futurefit_db.AppClient>, common.Paginated<totalinteraction_futurefit_frontend.UserGroupListEntry>>,
  queryUserGroupManagers: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.UserGroupManager>>>,
  queryUserGroupMembers: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.UserGroupMember>>>,
  queryUserGroupViewers: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.UserGroupViewer>>>,
  queryUserGroups: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.UserGroup>>>,
  queryUserQuizs: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.UserQuiz>>>,
  queryUserTrainingOfferings: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.UserTrainingOffering>>>,
  queryUserUploadRecords: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.UserUploadRecord>>>,
  queryUserUploadSets: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.UserUploadSet>>>,
  queryUsers: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.AppUser>>>,
  queryWorkRoleList: PostRequest<common_tabular.TableQuery, common.Paginated<totalinteraction_futurefit_frontend.WorkRoleListEntry>>,
  queryWorkRoleReferenceData: GetRequest<totalinteraction_futurefit_requests.WorkRoleReferenceData>,
  queryWorkRoleScoreRanges: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.WorkRoleScoreRange>>>,
  queryWorkRoleSkills: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.WorkRoleSkill>>>,
  queryWorkRoles: PostRequest<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<totalinteraction_futurefit_db.WorkRole>>>,
  quizAnswerQuestion: PostRequest<totalinteraction_futurefit_requests.QuizAnswerQuestionReq, common.Unit>,
  quizQuestionEvent: PostRequest<totalinteraction_futurefit_requests.QuizQuestionEventReq, common.Unit>,
  quizSendReminders: PostRequest<totalinteraction_futurefit_requests.QuizSendRemindersReq, common.Unit>,
  readEvent: PostRequest<totalinteraction_futurefit_frontend.InputEvent, totalinteraction_futurefit_db_learningevent.LearningEvent>,
  recreateUserQuiz: PostRequest<totalinteraction_futurefit_db.UserQuiz, common_db.DbKey<totalinteraction_futurefit_db.UserQuiz>>,
  saveSyntheticCompletionEvent: PostRequest<totalinteraction_futurefit_db_learningevent.CompletionEvent, common_db.DbKey<totalinteraction_futurefit_db_learningevent.ScodleEventLog>>,
  selfAssessmentAnswerQuestion: PostRequest<totalinteraction_futurefit_requests.SelfAssessmentAnswerQuestionReq, common.Unit>,
  skillTrainingOfferingReport: PostRequest<common.Unit, totalinteraction_futurefit_frontend.SkillTrainingOfferingMatrix>,
  trackedLink: PostRequest<totalinteraction_futurefit_requests.LaunchTrainingOfferingReq, totalinteraction_futurefit_requests.TrackedLinkResp>,
  updateAppClient: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.AppClient>, common.Unit>,
  updateAppClientLicence: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.AppClientLicence>, common.Unit>,
  updateAuth0Client: PostRequest<totalinteraction_futurefit_requests.UpdateAuth0ClientReq, totalinteraction_futurefit_frontend.Auth0Client>,
  updateAuth0SamlConnection: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.Auth0SamlConnection>, common.Unit>,
  updateAuth0Tenant: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.Auth0Tenant>, common.Unit>,
  updateCompetency: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.Competency>, common.Unit>,
  updateCompetencyTrainingOffering: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.CompetencyTrainingOffering>, common.Unit>,
  updateLang: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.Lang>, common.Unit>,
  updateLearningProvider: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.LearningProvider>, common.Unit>,
  updateLearningProviderCatalogEntry: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.LearningProviderCatalogEntry>, common.Unit>,
  updateLicence: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.Licence>, common.Unit>,
  updateQuestion: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.Question>, common.Unit>,
  updateQuiz: PostRequest<totalinteraction_futurefit_requests.UpdateQuizReq, common.Unit>,
  updateQuizQuestion: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.QuizQuestion>, common.Unit>,
  updateQuizSkill: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.QuizSkill>, common.Unit>,
  updateReport: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.Report>, common.Unit>,
  updateRoleBuilderData: PostRequest<totalinteraction_futurefit_frontend.RoleBuilderUpdates, common.Unit>,
  updateScodleControl: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db_scodlemigration.ScodleControl>, common.Unit>,
  updateScodleEvent: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db_learningevent.ScodleEventLog>, common.Unit>,
  updateSkill: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.Skill>, common.Unit>,
  updateSkillTrainingOffering: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.SkillTrainingOffering>, common.Unit>,
  updateTrainingOffering: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.TrainingOffering>, common.Unit>,
  updateUser: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.AppUser>, common.Unit>,
  updateUserGroup: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.UserGroup>, common.Unit>,
  updateUserGroupManager: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.UserGroupManager>, common.Unit>,
  updateUserGroupMember: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.UserGroupMember>, common.Unit>,
  updateUserGroupViewer: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.UserGroupViewer>, common.Unit>,
  updateUserQuiz: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.UserQuiz>, common.Unit>,
  updateUserTrainingOffering: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.UserTrainingOffering>, common.Unit>,
  updateUserUploadRecord: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.UserUploadRecord>, common.Unit>,
  updateUserUploadSet: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.UserUploadSet>, common.Unit>,
  updateWorkRole: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.WorkRole>, common.Unit>,
  updateWorkRoleScoreRange: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.WorkRoleScoreRange>, common.Unit>,
  updateWorkRoleSkill: PostRequest<common_db.WithDbId<totalinteraction_futurefit_db.WorkRoleSkill>, common.Unit>,
  updateWorkRoleWithRanges: PostRequest<totalinteraction_futurefit_requests.UpdateWorkRoleReq, common.Unit>,
  uploadRepositoryEntry: PostRequest<totalinteraction_futurefit_requests.RepositoryPutReq, totalinteraction_futurefit_frontend.Entry>,
  userHome: PostRequest<common.Unit, totalinteraction_futurefit_frontend.UserQuizData>,
  userLogin: PostRequest<common.Unit, totalinteraction_futurefit_requests.UserLoginResp>,
  userQuizResults: PostRequest<totalinteraction_futurefit_requests.UserQuizResultsReq, totalinteraction_futurefit_requests.SingleUserResults>,
  userQuizResultsForRole: PostRequest<totalinteraction_futurefit_requests.UserQuizResultsForRoleReq, totalinteraction_futurefit_requests.SingleUserResults>,
};

export function makeRequestTypes(resolver: ADL.DeclResolver): RequestTypes {
  /**
   * Provide non-admin access to query available languages
   */
  const availableLangs = {
    path: "/lang/available",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprLang()))),
  }

  /**
   * Read, decode, and save decoded event
   * Server typed POST API will not be used for this
   */
  const captureEvent = {
    path: "/events/capture",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_frontend.texprInputEvent()),
    respJB: JSON.createJsonBinding(resolver, ADL.texprString()),
  }

  /**
   * Route for backend to check the auth0 jwt
   */
  const checkAuth = {
    path: "/user/check_auth",
    respJB: JSON.createJsonBinding(resolver, ADL.texprNullable(common_db.texprDbKey(totalinteraction_futurefit_db.texprAppUser()))),
  }

  const clientParticipantsReport = {
    path: "/reports/client-participants",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprAppClient())),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(totalinteraction_futurefit_frontend.texprClientParticipant())),
  }

  /**
   * Create WorkRole and associated Ranges - and (on the Server) clone 
   * any WorkRoleSkills
   */
  const cloneWorkRole = {
    path: "/role/clone",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprCloneWorkRoleReq()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprWorkRole())),
  }

  /**
   * Ensure UserQuiz is marked complete - non-Admin API
   */
  const completeUserQuiz = {
    path: "/self-assessment/complete-user-quiz",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprUserQuiz())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const createAppClient = {
    path: "/appclient/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprAppClient()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprAppClient())),
  }

  const createAppClientLicence = {
    path: "/appclientlicence/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprAppClientLicence()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprAppClientLicence())),
  }

  /**
   * FF2-134: Enhance appClient create to also create 'global' UserGroup
   */
  const createAppClientWithGroup = {
    path: "/appclient/create-with-group",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprAppClient()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprAppClient())),
  }

  const createAuth0Client = {
    path: "/auth0client/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprCreateAuth0ClientReq()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_frontend.texprAuth0Client()),
  }

  const createAuth0SamlConnection = {
    path: "/saml/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprAuth0SamlConnection()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprAuth0SamlConnection())),
  }

  const createAuth0Tenant = {
    path: "/auth0tenant/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprAuth0Tenant()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprAuth0Tenant())),
  }

  const createCompetency = {
    path: "/competency/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprCompetency()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprCompetency())),
  }

  const createCompetencyTrainingOffering = {
    path: "/competencytrainingoffering/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprCompetencyTrainingOffering()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprCompetencyTrainingOffering())),
  }

  const createLang = {
    path: "/lang/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprLang()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprLang())),
  }

  const createLearningProvider = {
    path: "/learningprovider/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprLearningProvider()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprLearningProvider())),
  }

  const createLearningProviderCatalogEntry = {
    path: "/learningprovidercatalog/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprLearningProviderCatalogEntry()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprLearningProviderCatalogEntry())),
  }

  const createLearningProviderEnrolment = {
    path: "/lpapi/create-enrolment",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprLPEnrolmentCreateReq()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_lpapi.texprResponseType(totalinteraction_futurefit_lpapi.texprEnrolment())),
  }

  const createLearningProviderUser = {
    path: "/lpapi/create-user",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprLPUserCreateReq()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_lpapi.texprResponseType(totalinteraction_futurefit_lpapi.texprUser())),
  }

  const createLicence = {
    path: "/licence/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprLicence()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprLicence())),
  }

  const createQuestion = {
    path: "/question/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprQuestion()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprQuestion())),
  }

  /**
   * Create a quiz by cloning details associated with the
   * specified work role
   */
  const createQuiz = {
    path: "/quiz/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprCreateQuizReq()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprQuiz())),
  }

  const createReport = {
    path: "/report/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprReport()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprReport())),
  }

  const createScodleControl = {
    path: "/scodle/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db_scodlemigration.texprScodleControl()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db_scodlemigration.texprScodleControl())),
  }

  const createScodleEvent = {
    path: "/scodle_event/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db_learningevent.texprScodleEventLog()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db_learningevent.texprScodleEventLog())),
  }

  const createSkill = {
    path: "/skill/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprSkill()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprSkill())),
  }

  const createSkillTrainingOffering = {
    path: "/skilltrainingoffering/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprSkillTrainingOffering()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprSkillTrainingOffering())),
  }

  const createTrainingOffering = {
    path: "/trainingoffering/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprTrainingOffering()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprTrainingOffering())),
  }

  const createUser = {
    path: "/appuser/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprAppUser()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprAppUser())),
  }

  const createUserGroup = {
    path: "/usergroup/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprUserGroup()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprUserGroup())),
  }

  const createUserGroupManager = {
    path: "/usergroupmanager/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprUserGroupManager()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprUserGroupManager())),
  }

  const createUserGroupMember = {
    path: "/usergroupmember/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprUserGroupMember()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprUserGroupMember())),
  }

  const createUserGroupViewer = {
    path: "/usergroupviewer/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprUserGroupViewer()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprUserGroupViewer())),
  }

  const createUserQuiz = {
    path: "/userquiz/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprUserQuiz()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprUserQuiz())),
  }

  const createUserTrainingOffering = {
    path: "/usertrainingoffering/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprUserTrainingOffering()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprUserTrainingOffering())),
  }

  const createUserUploadRecord = {
    path: "/user_upload/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprUserUploadRecord()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprUserUploadRecord())),
  }

  const createUserUploadSet = {
    path: "/user_upload_set/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprUserUploadSet()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprUserUploadSet())),
  }

  /**
   * FF2-134: Enhance AppUser create to also add to 'global' UserGroup if it exists
   */
  const createUserWithGroup = {
    path: "/users/create-with-group",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprAppUser()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprAppUser())),
  }

  const createWorkRole = {
    path: "/workrole/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprWorkRole()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprWorkRole())),
  }

  const createWorkRoleScoreRange = {
    path: "/scorerange/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprWorkRoleScoreRange()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprWorkRoleScoreRange())),
  }

  const createWorkRoleSkill = {
    path: "/workroleskill/create",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprWorkRoleSkill()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprWorkRoleSkill())),
  }

  /**
   * Extended role APIs
   * Create WorkRole and associated WorkRoleScoreRange
   */
  const createWorkRoleWithRanges = {
    path: "/role/create-with-ranges",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprCreateWorkRoleReq()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprWorkRole())),
  }

  const deleteAppClient = {
    path: "/appclient/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprAppClient())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteAppClientLicence = {
    path: "/appclientlicence/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprAppClientLicence())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteAuth0SamlConnection = {
    path: "/saml/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprAuth0SamlConnection())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteAuth0Tenant = {
    path: "/auth0tenant/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprAuth0Tenant())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteCompetency = {
    path: "/competency/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprCompetency())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteCompetencyTrainingOffering = {
    path: "/competencytrainingoffering/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprCompetencyTrainingOffering())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteLang = {
    path: "/lang/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprLang())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteLearningProvider = {
    path: "/learningprovider/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprLearningProvider())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteLearningProviderCatalogEntry = {
    path: "/learningprovidercatalog/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprLearningProviderCatalogEntry())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteLicence = {
    path: "/licence/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprLicence())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteQuestion = {
    path: "/question/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprQuestion())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteReport = {
    path: "/report/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprReport())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  /**
   * Delete an entry - checked to ensure prefixes are not deleted, only non-prefix non-zero-length objects
   */
  const deleteRepositoryEntry = {
    path: "/resources/deleteobject",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprRepositoryReq()),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteScodleControl = {
    path: "/scodle/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db_scodlemigration.texprScodleControl())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteScodleEvent = {
    path: "/scodle_event/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db_learningevent.texprScodleEventLog())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteSkill = {
    path: "/skill/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprSkill())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteSkillTrainingOffering = {
    path: "/skilltrainingoffering/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprSkillTrainingOffering())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteTrainingOffering = {
    path: "/trainingoffering/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprTrainingOffering())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteUser = {
    path: "/appuser/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprAppUser())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteUserGroup = {
    path: "/usergroup/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprUserGroup())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteUserGroupManager = {
    path: "/usergroupmanager/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprUserGroupManager())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteUserGroupMember = {
    path: "/usergroupmember/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprUserGroupMember())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteUserGroupViewer = {
    path: "/usergroupviewer/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprUserGroupViewer())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteUserQuiz = {
    path: "/userquiz/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprUserQuiz())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteUserTrainingOffering = {
    path: "/usertrainingoffering/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprUserTrainingOffering())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteUserUploadRecord = {
    path: "/user_upload/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprUserUploadRecord())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteUserUploadSet = {
    path: "/user_upload_set/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprUserUploadSet())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteWorkRole = {
    path: "/workrole/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprWorkRole())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteWorkRoleScoreRange = {
    path: "/scorerange/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprWorkRoleScoreRange())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const deleteWorkRoleSkill = {
    path: "/workroleskill/delete",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprWorkRoleSkill())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  /**
   * Delete WorkRole and associated Ranges and WorkRoleSkills
   */
  const deleteWorkRoleWithRanges = {
    path: "/role/delete-all",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprWorkRole())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const generateCompletionEvent = {
    path: "/events/completion_event",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db_learningevent.texprCompletionEvent()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_frontend.texprInputEvent()),
  }

  const generateLoginEvent = {
    path: "/events/login_event",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db_learningevent.texprLoginEvent()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_frontend.texprInputEvent()),
  }

  const generateViewEvent = {
    path: "/events/view_event",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db_learningevent.texprViewEvent()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_frontend.texprInputEvent()),
  }

  /**
   * Get a completion event associated with a specific training offering/userid
   */
  const getCompletionEvent = {
    path: "/training-offering/completion-event",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprLaunchTrainingOfferingReq()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprCompletionEventResp()),
  }

  /**
   * Get the next question in the specified quiz to be presented to
   * the user.
   */
  const getNextQuestion = {
    path: "/quiz/get-next-question",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprUserQuiz())),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprNextQuestionResp()),
  }

  /**
   * Given a user quiz ID, pull out the associated WorkRoleListEntry
   */
  const getWorkRoleForUserQuiz = {
    path: "/self-assessment/user-quiz-work-role",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprUserQuiz())),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_frontend.texprWorkRoleListEntry()),
  }

  /**
   * Intercept training offering launch
   * Server typed POST API may not be used for this - response may be replaced
   * by a 303 redirection
   */
  const launchTrainingOffering = {
    path: "/training-offering/launch",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprLaunchTrainingOfferingReq()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprLaunchTrainingOfferingResp()),
  }

  /**
   * ----- [ Auth0 Client management ] ------------------------------------
   */
  const listAuth0Clients = {
    path: "/auth0client/list",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(totalinteraction_futurefit_frontend.texprAuth0Client())),
  }

  /**
   * ----- [ AWS Resources management ] ------------------------------------
   * List objects in a repository, optionally filtered on a specific key. If this key is a specific object,
   * just that is returned. If the key is a prefix, all and only items with that prefix are returned.
   * Also pass AppClientId for authentication
   */
  const listRepositoryEntries = {
    path: "/resources/list",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprRepositoryReq()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_frontend.texprRepositoryEntries()),
  }

  const processUserUpload = {
    path: "/user_upload/process",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprUserUploadData()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprUserUploadResult()),
  }

  /**
   * Delete a User Quiz and all associated records (submissions, events, training offerings)
   */
  const purgeUserQuiz = {
    path: "/userquiz/purge",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprUserQuiz())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const queryAppClientLicences = {
    path: "/appclientlicence/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprAppClientLicence()))),
  }

  const queryAppClientList = {
    path: "/appclient/query-list",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(totalinteraction_futurefit_frontend.texprAppClientListEntry())),
  }

  const queryAppClients = {
    path: "/appclient/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprAppClient()))),
  }

  const queryAppUserData = {
    path: "/appuser/query-data",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprAppClient())),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprUserData()),
  }

  const queryAppUserList = {
    path: "/appuser/query-list",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprAppClient())),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(totalinteraction_futurefit_frontend.texprAppUserListEntry())),
  }

  const queryAuth0SamlConnections = {
    path: "/saml/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprAuth0SamlConnection()))),
  }

  const queryAuth0Tenants = {
    path: "/auth0tenant/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprAuth0Tenant()))),
  }

  const queryComparisonRoles = {
    path: "/quiz/comparison-roles",
    reqJB: JSON.createJsonBinding(resolver, common.texprUnit()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_frontend.texprComparisonRoles()),
  }

  const queryCompetencies = {
    path: "/competency/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprCompetency()))),
  }

  const queryCompetencyTrainingOfferings = {
    path: "/competencytrainingoffering/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprCompetencyTrainingOffering()))),
  }

  const queryGroupResultsScoreSet = {
    path: "/quiz-report/group-score-set",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprGroupResultScoreSetReq()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_frontend.texprResultsScoreSet()),
  }

  const queryLangs = {
    path: "/lang/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprLang()))),
  }

  /**
   * Test std method wrapping indirect call to Scodle API (via server) TODO: Generalize
   */
  const queryLearningProviderCatalog = {
    path: "/lpapi/get-catalog",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprLearningProvider())),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_lpapi.texprResponseType(totalinteraction_futurefit_lpapi.texprResultsType(totalinteraction_futurefit_lpapi.texprCatalogEntry()))),
  }

  const queryLearningProviderCatalogEntrys = {
    path: "/learningprovidercatalog/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprLearningProviderCatalogEntry()))),
  }

  const queryLearningProviderEnrolment = {
    path: "/lpapi/get-enrolment",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprEnrolmentQueryReq()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_lpapi.texprResponseType(totalinteraction_futurefit_lpapi.texprResultsType(totalinteraction_futurefit_lpapi.texprEnrolment()))),
  }

  const queryLearningProviderUser = {
    path: "/lpapi/get-user",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprLPUserQueryReq()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_lpapi.texprResponseType(totalinteraction_futurefit_lpapi.texprResultsType(totalinteraction_futurefit_lpapi.texprUser()))),
  }

  const queryLearningProviders = {
    path: "/learningprovider/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprLearningProvider()))),
  }

  const queryLicences = {
    path: "/licence/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprLicence()))),
  }

  const queryQuestions = {
    path: "/question/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprQuestion()))),
  }

  const queryQuizQuestions = {
    path: "/quizquestion/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprQuizQuestion()))),
  }

  /**
   * new development endpoint to fixup /quiz-report/results
   */
  const queryQuizReportMulti = {
    path: "/quiz-report/results",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprQueryQuizReportResultsReq()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_frontend.texprMultiUserQuizResults()),
  }

  /**
   * Get the users that are participants in the specified quiz
   */
  const queryQuizReportParticipants = {
    path: "/quiz-report/participants",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprQueryQuizReportParticipantsReq()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_frontend.texprUsersGroupsMap()),
  }

  const queryQuizReportRaw = {
    path: "/quiz-report/raw-results",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprQueryQuizReportRawResultsReq()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprTempMultiUserQuizResultsRaw()),
  }

  /**
   * Query the list of quizzes that can be viewed by
   * a user (ie a manager)"
   */
  const queryQuizReports = {
    path: "/quiz-report/query",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprAppUser())),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(totalinteraction_futurefit_requests.texprQuizReportSummary())),
  }

  const queryQuizSkills = {
    path: "/quizskill/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprQuizSkill()))),
  }

  const queryQuizTrainingRecommendations = {
    path: "/quiz-report/recommendations",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprQueryQuizTrainingOfferingsDataReq()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_frontend.texprMultiUserTrainingRecommendations()),
  }

  const queryQuizzes = {
    path: "/quiz/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprQuiz()))),
  }

  /**
   * Query the quizzes available to the specified user, and return
   * their progress status. Non-admin users can only access details
   * of their own quizzes
   */
  const queryQuizzesForUser = {
    path: "/quiz/query-for-user",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprAppUser())),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(totalinteraction_futurefit_frontend.texprUserQuizSummary())),
  }

  const queryReports = {
    path: "/report/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprReport()))),
  }

  /**
   * RoleBuilder - get current data
   */
  const queryRoleBuilderData = {
    path: "/role-builder/query-role",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprWorkRole())),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_frontend.texprRoleBuilderData()),
  }

  const queryScodleControls = {
    path: "/scodle/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db_scodlemigration.texprScodleControl()))),
  }

  const queryScodleEvents = {
    path: "/scodle_event/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db_learningevent.texprScodleEventLog()))),
  }

  /**
   * Recommendations - get lookup data for lists of training offerings
   */
  const querySkillData = {
    path: "/skills/query-data",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprQuerySkillDataReq()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_frontend.texprSkillData()),
  }

  const querySkillTrainingOfferings = {
    path: "/skilltrainingoffering/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprSkillTrainingOffering()))),
  }

  const querySkills = {
    path: "/skill/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprSkill()))),
  }

  /**
   * Recommendations - get lookup data for lists of training offerings
   */
  const queryTrainingOfferingData = {
    path: "/recommendations/query-data",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprQueryTrainingOfferingDataReq()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_frontend.texprTrainingOfferingData()),
  }

  const queryTrainingOfferings = {
    path: "/trainingoffering/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprTrainingOffering()))),
  }

  /**
   * AusPost User Report - every completed attempt per participant, across all of a
   * client's quizzes (unlike QueryQuizReportRaw, which truncates to current+previous)
   */
  const queryUserAttemptHistory = {
    path: "/quiz-report/user-history",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprQueryUserAttemptHistoryReq()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprUserAttemptHistoryRaw()),
  }

  const queryUserGroupData = {
    path: "/usergroup/query-data",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprAppClient())),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprGroupData()),
  }

  const queryUserGroupList = {
    path: "/usergroup/query-list",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprAppClient())),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(totalinteraction_futurefit_frontend.texprUserGroupListEntry())),
  }

  const queryUserGroupManagers = {
    path: "/usergroupmanager/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprUserGroupManager()))),
  }

  const queryUserGroupMembers = {
    path: "/usergroupmember/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprUserGroupMember()))),
  }

  const queryUserGroupViewers = {
    path: "/usergroupviewer/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprUserGroupViewer()))),
  }

  const queryUserGroups = {
    path: "/usergroup/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprUserGroup()))),
  }

  const queryUserQuizs = {
    path: "/userquiz/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprUserQuiz()))),
  }

  const queryUserTrainingOfferings = {
    path: "/usertrainingoffering/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprUserTrainingOffering()))),
  }

  const queryUserUploadRecords = {
    path: "/user_upload/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprUserUploadRecord()))),
  }

  const queryUserUploadSets = {
    path: "/user_upload_set/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprUserUploadSet()))),
  }

  const queryUsers = {
    path: "/appuser/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprAppUser()))),
  }

  const queryWorkRoleList = {
    path: "/workrole/query-list",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(totalinteraction_futurefit_frontend.texprWorkRoleListEntry())),
  }

  const queryWorkRoleReferenceData = {
    path: "/workrole/query-data",
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprWorkRoleReferenceData()),
  }

  const queryWorkRoleScoreRanges = {
    path: "/scorerange/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprWorkRoleScoreRange()))),
  }

  const queryWorkRoleSkills = {
    path: "/workroleskill/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprWorkRoleSkill()))),
  }

  const queryWorkRoles = {
    path: "/workrole/query",
    reqJB: JSON.createJsonBinding(resolver, common_tabular.texprTableQuery()),
    respJB: JSON.createJsonBinding(resolver, common.texprPaginated(common_db.texprWithDbId(totalinteraction_futurefit_db.texprWorkRole()))),
  }

  /**
   * Submit an answer to the specified question
   */
  const quizAnswerQuestion = {
    path: "/quiz/answer-question",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprQuizAnswerQuestionReq()),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  /**
   * Post an event as a user works through a questionaire
   */
  const quizQuestionEvent = {
    path: "/quiz/question-event",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprQuizQuestionEventReq()),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  /**
   * Send reminders for quizzes
   */
  const quizSendReminders = {
    path: "/quiz/reminders",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprQuizSendRemindersReq()),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  /**
   * Read, decode, and return decoded event
   * Server typed POST API will not be used for this
   */
  const readEvent = {
    path: "/events/read",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_frontend.texprInputEvent()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db_learningevent.texprLearningEvent()),
  }

  /**
   * FF2-355 Recreate the user quiz (wrapper for /userquiz/create)
   */
  const recreateUserQuiz = {
    path: "/quiz/recreate",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db.texprUserQuiz()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db.texprUserQuiz())),
  }

  /**
   * Save synthetic CompletionEvent and return event log ID 
   * (for testing embedded offerings in non-Production environments
   * where there's no webhook from TIA Admin)
   */
  const saveSyntheticCompletionEvent = {
    path: "/events/create-completion-event",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_db_learningevent.texprCompletionEvent()),
    respJB: JSON.createJsonBinding(resolver, common_db.texprDbKey(totalinteraction_futurefit_db_learningevent.texprScodleEventLog())),
  }

  /**
   * Submit an answer to the specified self-assessment question
   */
  const selfAssessmentAnswerQuestion = {
    path: "/self-assessment/answer-question",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprSelfAssessmentAnswerQuestionReq()),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const skillTrainingOfferingReport = {
    path: "/reports/skill-training-offering-matrix",
    reqJB: JSON.createJsonBinding(resolver, common.texprUnit()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_frontend.texprSkillTrainingOfferingMatrix()),
  }

  /**
   * One-time link used for embedded TIAOnline offerings
   */
  const trackedLink = {
    path: "/training-offering/tracked-link",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprLaunchTrainingOfferingReq()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprTrackedLinkResp()),
  }

  const updateAppClient = {
    path: "/appclient/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprAppClient())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateAppClientLicence = {
    path: "/appclientlicence/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprAppClientLicence())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateAuth0Client = {
    path: "/auth0client/update",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprUpdateAuth0ClientReq()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_frontend.texprAuth0Client()),
  }

  const updateAuth0SamlConnection = {
    path: "/saml/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprAuth0SamlConnection())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateAuth0Tenant = {
    path: "/auth0tenant/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprAuth0Tenant())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateCompetency = {
    path: "/competency/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprCompetency())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateCompetencyTrainingOffering = {
    path: "/competencytrainingoffering/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprCompetencyTrainingOffering())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateLang = {
    path: "/lang/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprLang())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateLearningProvider = {
    path: "/learningprovider/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprLearningProvider())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateLearningProviderCatalogEntry = {
    path: "/learningprovidercatalog/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprLearningProviderCatalogEntry())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateLicence = {
    path: "/licence/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprLicence())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateQuestion = {
    path: "/question/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprQuestion())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  /**
   * Update a Quiz. For the moment, use only the attributes available in QuizListEntry.
   */
  const updateQuiz = {
    path: "/quiz/update",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprUpdateQuizReq()),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateQuizQuestion = {
    path: "/quizquestion/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprQuizQuestion())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateQuizSkill = {
    path: "/quizskill/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprQuizSkill())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateReport = {
    path: "/report/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprReport())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  /**
   * RoleBuilder - send update data
   */
  const updateRoleBuilderData = {
    path: "/role-builder/update-role",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_frontend.texprRoleBuilderUpdates()),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateScodleControl = {
    path: "/scodle/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db_scodlemigration.texprScodleControl())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateScodleEvent = {
    path: "/scodle_event/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db_learningevent.texprScodleEventLog())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateSkill = {
    path: "/skill/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprSkill())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateSkillTrainingOffering = {
    path: "/skilltrainingoffering/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprSkillTrainingOffering())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateTrainingOffering = {
    path: "/trainingoffering/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprTrainingOffering())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateUser = {
    path: "/appuser/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprAppUser())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateUserGroup = {
    path: "/usergroup/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprUserGroup())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateUserGroupManager = {
    path: "/usergroupmanager/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprUserGroupManager())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateUserGroupMember = {
    path: "/usergroupmember/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprUserGroupMember())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateUserGroupViewer = {
    path: "/usergroupviewer/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprUserGroupViewer())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateUserQuiz = {
    path: "/userquiz/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprUserQuiz())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateUserTrainingOffering = {
    path: "/usertrainingoffering/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprUserTrainingOffering())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateUserUploadRecord = {
    path: "/user_upload/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprUserUploadRecord())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateUserUploadSet = {
    path: "/user_upload_set/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprUserUploadSet())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateWorkRole = {
    path: "/workrole/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprWorkRole())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateWorkRoleScoreRange = {
    path: "/scorerange/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprWorkRoleScoreRange())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  const updateWorkRoleSkill = {
    path: "/workroleskill/update",
    reqJB: JSON.createJsonBinding(resolver, common_db.texprWithDbId(totalinteraction_futurefit_db.texprWorkRoleSkill())),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  /**
   * Update WorkRole and associated Ranges
   */
  const updateWorkRoleWithRanges = {
    path: "/role/update-with-ranges",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprUpdateWorkRoleReq()),
    respJB: JSON.createJsonBinding(resolver, common.texprUnit()),
  }

  /**
   * Upload an entry
   * Also pass AppClientId for authentication
   */
  const uploadRepositoryEntry = {
    path: "/resources/uploadobject",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprRepositoryPutReq()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_frontend.texprEntry()),
  }

  const userHome = {
    path: "/user/home",
    reqJB: JSON.createJsonBinding(resolver, common.texprUnit()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_frontend.texprUserQuizData()),
  }

  /**
   * Ensure AppUser table entry exists for user from Auth0
   */
  const userLogin = {
    path: "/user/login",
    reqJB: JSON.createJsonBinding(resolver, common.texprUnit()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprUserLoginResp()),
  }

  /**
   * Get user quiz results - consolidated to get recommendations at the same time
   */
  const userQuizResults = {
    path: "/quiz/user-results",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprUserQuizResultsReq()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprSingleUserResults()),
  }

  /**
   * Get user quiz results for a specific role comparison
   */
  const userQuizResultsForRole = {
    path: "/quiz/user-results-for-role",
    reqJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprUserQuizResultsForRoleReq()),
    respJB: JSON.createJsonBinding(resolver, totalinteraction_futurefit_requests.texprSingleUserResults()),
  }
  return {
    availableLangs,
    captureEvent,
    checkAuth,
    clientParticipantsReport,
    cloneWorkRole,
    completeUserQuiz,
    createAppClient,
    createAppClientLicence,
    createAppClientWithGroup,
    createAuth0Client,
    createAuth0SamlConnection,
    createAuth0Tenant,
    createCompetency,
    createCompetencyTrainingOffering,
    createLang,
    createLearningProvider,
    createLearningProviderCatalogEntry,
    createLearningProviderEnrolment,
    createLearningProviderUser,
    createLicence,
    createQuestion,
    createQuiz,
    createReport,
    createScodleControl,
    createScodleEvent,
    createSkill,
    createSkillTrainingOffering,
    createTrainingOffering,
    createUser,
    createUserGroup,
    createUserGroupManager,
    createUserGroupMember,
    createUserGroupViewer,
    createUserQuiz,
    createUserTrainingOffering,
    createUserUploadRecord,
    createUserUploadSet,
    createUserWithGroup,
    createWorkRole,
    createWorkRoleScoreRange,
    createWorkRoleSkill,
    createWorkRoleWithRanges,
    deleteAppClient,
    deleteAppClientLicence,
    deleteAuth0SamlConnection,
    deleteAuth0Tenant,
    deleteCompetency,
    deleteCompetencyTrainingOffering,
    deleteLang,
    deleteLearningProvider,
    deleteLearningProviderCatalogEntry,
    deleteLicence,
    deleteQuestion,
    deleteReport,
    deleteRepositoryEntry,
    deleteScodleControl,
    deleteScodleEvent,
    deleteSkill,
    deleteSkillTrainingOffering,
    deleteTrainingOffering,
    deleteUser,
    deleteUserGroup,
    deleteUserGroupManager,
    deleteUserGroupMember,
    deleteUserGroupViewer,
    deleteUserQuiz,
    deleteUserTrainingOffering,
    deleteUserUploadRecord,
    deleteUserUploadSet,
    deleteWorkRole,
    deleteWorkRoleScoreRange,
    deleteWorkRoleSkill,
    deleteWorkRoleWithRanges,
    generateCompletionEvent,
    generateLoginEvent,
    generateViewEvent,
    getCompletionEvent,
    getNextQuestion,
    getWorkRoleForUserQuiz,
    launchTrainingOffering,
    listAuth0Clients,
    listRepositoryEntries,
    processUserUpload,
    purgeUserQuiz,
    queryAppClientLicences,
    queryAppClientList,
    queryAppClients,
    queryAppUserData,
    queryAppUserList,
    queryAuth0SamlConnections,
    queryAuth0Tenants,
    queryComparisonRoles,
    queryCompetencies,
    queryCompetencyTrainingOfferings,
    queryGroupResultsScoreSet,
    queryLangs,
    queryLearningProviderCatalog,
    queryLearningProviderCatalogEntrys,
    queryLearningProviderEnrolment,
    queryLearningProviderUser,
    queryLearningProviders,
    queryLicences,
    queryQuestions,
    queryQuizQuestions,
    queryQuizReportMulti,
    queryQuizReportParticipants,
    queryQuizReportRaw,
    queryQuizReports,
    queryQuizSkills,
    queryQuizTrainingRecommendations,
    queryQuizzes,
    queryQuizzesForUser,
    queryReports,
    queryRoleBuilderData,
    queryScodleControls,
    queryScodleEvents,
    querySkillData,
    querySkillTrainingOfferings,
    querySkills,
    queryTrainingOfferingData,
    queryTrainingOfferings,
    queryUserAttemptHistory,
    queryUserGroupData,
    queryUserGroupList,
    queryUserGroupManagers,
    queryUserGroupMembers,
    queryUserGroupViewers,
    queryUserGroups,
    queryUserQuizs,
    queryUserTrainingOfferings,
    queryUserUploadRecords,
    queryUserUploadSets,
    queryUsers,
    queryWorkRoleList,
    queryWorkRoleReferenceData,
    queryWorkRoleScoreRanges,
    queryWorkRoleSkills,
    queryWorkRoles,
    quizAnswerQuestion,
    quizQuestionEvent,
    quizSendReminders,
    readEvent,
    recreateUserQuiz,
    saveSyntheticCompletionEvent,
    selfAssessmentAnswerQuestion,
    skillTrainingOfferingReport,
    trackedLink,
    updateAppClient,
    updateAppClientLicence,
    updateAuth0Client,
    updateAuth0SamlConnection,
    updateAuth0Tenant,
    updateCompetency,
    updateCompetencyTrainingOffering,
    updateLang,
    updateLearningProvider,
    updateLearningProviderCatalogEntry,
    updateLicence,
    updateQuestion,
    updateQuiz,
    updateQuizQuestion,
    updateQuizSkill,
    updateReport,
    updateRoleBuilderData,
    updateScodleControl,
    updateScodleEvent,
    updateSkill,
    updateSkillTrainingOffering,
    updateTrainingOffering,
    updateUser,
    updateUserGroup,
    updateUserGroupManager,
    updateUserGroupMember,
    updateUserGroupViewer,
    updateUserQuiz,
    updateUserTrainingOffering,
    updateUserUploadRecord,
    updateUserUploadSet,
    updateWorkRole,
    updateWorkRoleScoreRange,
    updateWorkRoleSkill,
    updateWorkRoleWithRanges,
    uploadRepositoryEntry,
    userHome,
    userLogin,
    userQuizResults,
    userQuizResultsForRole,
  }
};



// WEBPACK FOOTER //
// ./src/adl-gen/totalinteraction/futurefit/requests-rtypes.ts